import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeAdmin } from "../actions/removeAdmin";
import { useDispatch } from "react-redux";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";
import { AppDispatch } from "../../../redux/store";

export const useRemoveAdmin = () => {
  const qc = useQueryClient();
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationKey: ["removeAdmin"],
    mutationFn: (uid: string) => removeAdmin(uid),
    onSuccess: async () => {
      // refresh admins list + invitations (optional)
      await qc.invalidateQueries({ queryKey: ["admins"] });
      await qc.invalidateQueries({ queryKey: ["business-owner"] });
      await qc.invalidateQueries({ queryKey: ["invitations"] });
      dispatch(fetchBenefits());
    },
  });
};
